import { useFormContext } from 'react-hook-form';
import { PermittedReportsData } from '../types/permittedReports.type';
import ReportsFiltersField from './ReportsFiltersField';

interface ReportsFiltersFieldsProps {
  filters?: PermittedReportsData['filters'];
}

const ReportsFiltersFields = ({ filters }: ReportsFiltersFieldsProps) => {
  const { control, resetField, formState: { errors } } = useFormContext();

  return (
    <>
       {filters && Object.keys(filters)?.map((filterName) => (
        <ReportsFiltersField
          filterName={filterName}
          filterProps={filters[filterName]}
          control={control}
          errors={errors}
          resetField={resetField}
        />
      ))}
    </>
  );
};

export default ReportsFiltersFields;
